/**
 * The box FilterDropdown draws (border, corners, height, text). FilterTextInput and FilterDateRange use it too,
 * so a filter bar of mixed controls lines up. Add a width where it's used.
 */
export const FILTER_BOX = 'px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 '
  + 'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500';

/** The label above a filter, as FilterDropdown shows it. */
export const FILTER_LABEL = 'text-xs font-semibold';

/** For text, counts and text buttons in a filter bar: the height of a box, centred, so they line up with the boxes. */
export const FILTER_ITEM = 'inline-flex h-[34px] items-center';

/** The row of a filter bar: wraps, and lines everything up along the bottom (labels sit above boxes). */
export const FILTER_BAR = 'flex flex-wrap items-end gap-3';
